/**
 * Experience API 패키지 URL
 * @type {string}
 */
const packages = {
    services: '/services',
};

/**
 * Experience API 업무구분 URL
 * @type {string}
 */
const sectors = {
    services: {
        customer: `${packages.services}/customer`,
    },
};

/**
 * Experience API 업무 세구분 URL
 * @type {string}
 */
const details = {
    services: {
        customer: {
            inquiry: `${sectors.services.customer}/certificatesInquiry`,
            issue: `${sectors.services.customer}/certificatesIssue`,
            apply: `${sectors.services.customer}/certificatesApply`,
        },
    },
};

/**
 * Experience API 엔드포인트 URL
 * @type {string}
 */
export const APIS = {
    services: {
        customer: {
            inquiry: {
                listDepositBalance: `${details.services.customer.inquiry}/listDepositBalance`, //증명서 > 인터넷증명서 조회/발급 > 예금잔액증명서 발급내역
                listFinancialTransact: `${details.services.customer.inquiry}/listFinancialTransact`, //증명서 > 인터넷증명서 조회/발급 > 금융거래확인서 발급내역
                getDepositBalance: `${details.services.customer.inquiry}/getDepositBalance`, //증명서 > 인터넷증명서 조회/발급 > 예금잔액증명서 발급내역 > 증명서출력-국문
                getFinancialTransact: `${details.services.customer.inquiry}/getFinancialTransact`, //증명서 > 인터넷증명서 조회/발급 > 금융거래확인서 발급내역 > 증명서출력
                getDebtBalance: `${details.services.customer.inquiry}/getDebtBalance`, //증명서 > 인터넷증명서 조회/발급 > 부채잔액증명서 발급내역 > 증명서출력-국문
            },
            issue: {
                listAccount: `${details.services.customer.issue}/listAccount`,
                filteredAccount: `${details.services.customer.issue}/filteredAccount`,
                issueHouseMortgageLoanRate: `${details.services.customer.issue}/issueHouseMortgageLoanRate`,
                issueHouseCapitalRepay: `${details.services.customer.issue}/issueHouseCapitalRepay`,
                issueFinancialIncome: `${details.services.customer.issue}/issueFinancialIncome`,
                issueFinancialIncomeAccount: `${details.services.customer.issue}/issueFinancialIncomeAccount`,
                issueBusinessIncome: `${details.services.customer.issue}/issueBusinessIncome`,
            },
            apply: {
                listPaymentAccount: `${details.services.customer.apply}/listPaymentAccount`,
                getPoint: `${details.services.customer.apply}/getPoint`,
                inquiryLoanDebutGuarantee: `${details.services.customer.apply}/inquiryLoanDebutGuarantee`,
                executeFinancialTransactPre: `${details.services.customer.apply}/executeFinancialTransactPre`,
                executeFinancialTransactMain: `${details.services.customer.apply}/executeFinancialTransactMain`,
                executeDepositBalancePre: `${details.services.customer.apply}/executeDepositBalancePre`,
                executeDepositBalanceMain: `${details.services.customer.apply}/executeDepositBalanceMain`,
                executeDebtBalancePre: `${details.services.customer.apply}/executeDebtBalancePre`,
                executeDebtBalanceMain: `${details.services.customer.apply}/executeDebtBalanceMain`,
            },
        },
    },
};
